/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-24 14:31:53
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-26 22:40:18
 * @FilePath: /unifyxp-v2-store-portal/src/request/review/index.ts
 */
import { get, post, remove } from 'src/tools/server';

const getReview = (uuid?: string) => {
  return get(`/portal/productReviewsPage/${uuid}`, {});
};

const postReview = (review) => {
  return post('/portal/productReview', review, {});
};

const postReply = (reply) => {
  return post('/portal/productReview/reply', reply, {});
};

const deleteReply = (uuid) => {
  return remove(`/portal/productReview/reply/${uuid}`, {});
};

const deleteReview = (uuid) => {
  return remove(`/portal/productReview/${uuid}`, {});
};

const publishAll = (uuid?: string) => {
  return get(`/portal/productReview/publishAll/${uuid}`, {});
};

const unPublishAll = (uuid?: string) => {
  return get(`/portal/productReview/unPublishAll/${uuid}`, {});
};

const changeStatus = (uuid, status) => {
  return get(`/portal/productReview/changeStatus/${uuid}/${status}`, {});
};

const salesChannelOperations = (reply) => {
  return post('/portal/productReview/salesChannel/operations', reply, {});
};

const getInitReviewPage = (startIndex, pageCount, body) => {
  return post(
    `/portal/productReview/page/${startIndex || 0}/${pageCount || 10}`,
    body,
    {},
  );
};

const updateReviewPage = (startIndex, pageCount, body) => {
  return post(
    `/portal/productReview/search/${startIndex || 0}/${pageCount || 10}`,
    body,
    {},
  );
};

const exportReviews = (body) => {
  return post(`/portal/productReview/export`, body, {
    returnWholeData: true,
    responseType: 'arraybuffer',
  });
};

const getPendingReviewCount = () => {
  return get(`/portal/productReview/count/Pending`, { returnWholeData: true });
};

export {
  publishAll,
  unPublishAll,
  changeStatus,
  salesChannelOperations,
  getReview,
  postReview,
  postReply,
  deleteReply,
  deleteReview,
  getInitReviewPage,
  exportReviews,
  updateReviewPage,
  getPendingReviewCount,
};
